// src/components/Navbar/Navbar.js

import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { useNavigate, useLocation } from "react-router-dom"; // RouterLink is no longer needed here
import "./Navbar.css";
import logo from "../../Assets/logo.png"; // Make sure this path is correct

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [isScrolled, setIsScrolled] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const scrollTo = (id) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    } else {
      console.warn(`Element with ID "${id}" not found for scrolling.`);
      if (id === "home") { // Fallback for "home" specifically
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    if (sections.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveSection(entry.target.id);
            }
          });
        },
        { threshold: 0.3, rootMargin: "-50% 0px -50% 0px" } 
      );
      sections.forEach((section) => observer.observe(section));
      return () => sections.forEach((section) => observer.unobserve(section));
    } else {
      setActiveSection(""); 
    }
  }, [location.pathname]); 

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleLogoClick = () => {
    setMenuOpen(false);
    if (location.pathname === "/") {
      scrollTo("home"); 
    } else {
      navigate("/");
    }
  };

  let pageNavItems = [];
  if (location.pathname === "/") {
    pageNavItems = [
      { id: "weekly-program", label: "Wochenprogramm" },
      { id: "about", label: "Über uns" }, 
      { id: "highlights", label: "Highlights" }, 
      { id: "contact", label: "Kontakt" }, 
    ];
  } else if (location.pathname === "/about-us") {
    pageNavItems = [
      { id: "why-us-section", label: "Warum Wir" },
      { id: "statistics-section-aboutus", label: "Statistiken" },
      { id: "highlights-section-aboutus", label: "Unsere Werte" }, 
      { id: "board-members-section", label: "Vorstand" },
      { id: "faq-section-aboutus", label: "FAQ" },
    ];
  }
  // Add more else if blocks for other pages with scrollable sections if needed

  const showScrollNav = pageNavItems.length > 0;

  return ReactDOM.createPortal(
    <header className={`custom-navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="custom-navbar-container">
        <img
          src={logo}
          alt="VfB Logo"
          className="custom-navbar-logo"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        
        {/* Section scrolling navigation (burger menu on mobile) */}
        {showScrollNav && (
          <>
            <button className="burger" onClick={() => setMenuOpen(!menuOpen)}>
              <span className={`bar ${menuOpen ? "open" : ""}`}></span>
              <span className="burger-text">Menü</span>
            </button>
            <nav className={`nav-links scroll-nav ${menuOpen ? "open" : ""}`}>
              {pageNavItems.map((item) => (
                <button
                  key={item.id}
                  className={activeSection === item.id ? "active" : ""}
                  onClick={() => scrollTo(item.id)}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </>
        )}
      </div>
    </header>,
    document.getElementById("navbar-portal") 
  );
};

export default Navbar;